import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../../utils/Api";
import MachinesEditContainer from "./MachinesEditContainer";
import MachinesOverviewContainer from "./MachinesOverviewContainer";

class MachinesContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            currentCompany: this.props.baseData.companies.currentCompany,
            activeView: null,
            editRow: null,
            companies: [],
            machines: []
        };

        this.translate = this.props.baseData.translate;

        this.requestCompaniesForUser = this.requestCompaniesForUser.bind(this);
        this.changeView = this.changeView.bind(this);

    }

    componentWillMount() {

        this.requestCompaniesForUser();

    }

    requestCompaniesForUser() {

        const params = {
            action: 'getCompaniesForUser',
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
            companyId: this.props.baseData.companies.currentCompany.id,
            userId: this.props.baseData.userData.id
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    companies: res
                });
            }
        }.bind(this);

        this.api.request('AdminFunctions', params, callback, null);

    }

    changeView(activeView = null, editRow = null) {

        this.setState({
            activeView,
            editRow
        });

    }

    renderView() {

        const view = this.state.activeView;

        if (view === 'edit') {
            return <MachinesEditContainer
                baseData={this.props.baseData}
                machine={this.state.editRow}
                changeView={this.changeView}
            />;
        } else {
            return <MachinesOverviewContainer
                baseData={this.props.baseData}
                changeView={this.changeView}
            />;
        }

    }

    render() {

        const renderedView = this.renderView();

        return (
            <div>
                {renderedView}
            </div>
        );

    }

}

export default MachinesContainer;